import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import React, { Component, Fragment } from "react";
import { Auth } from "aws-amplify";
import { AuthService } from "./services/auth";
import { ConfigService } from "./services/config";
import {
  ConfirmSignIn,
  ConfirmSignUp,
  SignUp,
  VerifyContact,
  withAuthenticator,
} from "aws-amplify-react";
import { Route, BrowserRouter, Routes } from "react-router-dom";
import { connect } from "react-redux";
import "../config/amplify";
import "./App.scss";
import { ForgotPassword } from "./auth/ForgotPassword";
import { RequireNewPassword } from "./auth/RequireNewPassword";
import { ResetPassword } from "./auth/ResetPassword";
import { SignIn } from "./auth/SignIn";
import ExecSummary from "./settings/executiveSummary/execSummary";
import Settings from "./settings/settings";
import Dashboard from "./dashboard/dashboard";
import Navbar from "./Navbar";
import { ToastContainer, toast } from "react-toastify";
import SessionHandler from "../components/SessionHandler";
import { AppService } from "./services";
import { State } from "../models/app.models";
import OnboardHotel from "./onboard-hotel/onboardHotel";
import Users from "./settings/users/users";
import NewHotelConfig from "./settings/HotelConfig/NewHotelConfig";
import NewCompSetConfig from "./settings/CompSetConfig/NewCompSetConfig";
import RoomConfig from "./settings/RoomConfig/RoomConfig";
import HomePage from "../App/home-page/homePage";
import { UserApi } from "../api/user";
import PageNotFound from "./not-found/pageNotFound";
import Popup from "../reusable-components/popup/popup";
import { store } from "redux/store";
import { setMonthlyRateReminder } from "redux/Slice/userSlice";
import { resetYieldsheet } from "redux/Slice/yieldssheetSlice";
import { ACTIONS, hasPermission } from "./common/permissionHandler";
import { goToNewRevanista } from "../lib/goToNewRevanista";
import { signOutEverywhere } from "../lib/signOutEverywhere";
import UserDashboard from "./admin/userDashboard";

const NEW_REVA_ELIGIBLE_HOTEL_IDS: ReadonlySet<string> = new Set([
  "50",
  "1006",
]);

interface StateProps {
  activeHotel: {
    hotelId: number;
    info: {
      level: string;
    };
  };
  hotels: any[];
  user: any;
}

interface AppProps extends StateProps {
  authData: any;
  onStateChange: (state: string, data: any) => void;
  setMonthlyRateReminder: (value: boolean) => void;
}

class App extends Component<AppProps, State> {
  state = {
    username: null,
    permissions: null,
    count: 1,
    hotel: null,
    yieldSheetCheck: false,
    monthlyPopupValue: "false",
    invalidHotelId: false,
    isInitialized: false,
    isRedirectingToNewRevanista: false,
    hasDismissedNewRevanistaPrompt: false,
    hasDismissedMigrationNotice: false,
  };
  _isMounted = false;
  hotel: any;
  deleteFormula: any;
  settingHotel: any;
  users: any[] | undefined;
  otaCompSetList = [];

  constructor(props: any) {
    super(props);
    this.changeInvalidIdStaten = this.changeInvalidIdStaten.bind(this);
  }

  logout = async () => {
    try {
      await signOutEverywhere({
        onSignedOut: () => this.props.onStateChange("signedOut", null),
      });
    } catch (error) {
      console.error("Failed to sign out everywhere", error);
      this.props.onStateChange("signedOut", null);
    }
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    this._isMounted = true;
    const startNumber = /[a-zA-Z]/;
    const pathname = window.location.pathname;
    const part = pathname.split("/");

    store.dispatch(resetYieldsheet());

    // Validate route first
    if (part[1] && part[1].length !== 0) {
      const hotelId = parseInt(part[1]);
      if (isNaN(hotelId) || startNumber.test(part[1])) {
        this.setState({ invalidHotelId: true, isInitialized: true });
        return;
      }
    }

    await AuthService.revanista.user.identify();
    await AppService.revanista.initialize();
    const allHotels = this.props.hotels || [];
    const hotelIds = allHotels.map((data: any) => data.hotelId);
    if (
      part[1].length !== 0 &&
      (!hotelIds.includes(parseInt(part[1])) || startNumber.test(part[1]))
    ) {
      // check conditions in case of 1017e
      this.setState({ invalidHotelId: true });
      return;
    } else {
      ConfigService.revanista.hotel.configure();
    }
    if (this._isMounted) {
      this.setState({ isInitialized: true });
    }
  };

  fetchPopupValue = async () => {
    const monthlyRateReminder = this.props.user.monthlyRateReminder;
    this.setState({ monthlyPopupValue: monthlyRateReminder });
    console.log("monthlyRateReminder", monthlyRateReminder);
    console.log("monthlyPopupValue", this.state.monthlyPopupValue);
  };

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate() {
    const currentHotelId = this.getCurrentHotelId();
    const isEligible =
      currentHotelId != null && NEW_REVA_ELIGIBLE_HOTEL_IDS.has(currentHotelId);
    if (!isEligible && this.state.hasDismissedNewRevanistaPrompt) {
      this.setState({ hasDismissedNewRevanistaPrompt: false });
    }
  }

  changeInvalidIdStaten() {
    this.setState({ invalidHotelId: false });

    this.fetchData();
  }

  getHotelPropsData(data: any) {
    this.setState({ hotel: data });
  }

  handleOnPopupClose = async () => {
    const pathname = window.location.pathname;
    const parts = pathname.split("/");
    const firstRoute = parseInt(parts[1]);
    await UserApi.updateMonthlyPopupValue({
      hotelIds: firstRoute || this.props.activeHotel.hotelId,
      userEmail: this.props.user.username,
    })
      .then(async () => {
        this.props.setMonthlyRateReminder(false);
        try {
          await AuthService.revanista.user.identify();
          console.log("Auth session refreshed with new attributes");
        } catch (error) {
          console.error("Error refreshing auth session:", error);
        }
      })
      .catch((err) => console.log(err));
  };

  handleOnRemindMeLater = async () => {
    const pathname = window.location.pathname;
    const parts = pathname.split("/");
    const firstRoute = parseInt(parts[1]);
    await UserApi.remindMeLater({
      hotelIds: firstRoute || this.props.activeHotel.hotelId,
      userEmail: this.props.user.username,
    })
      .then(async () => {
        this.props.setMonthlyRateReminder(false);
        try {
          await AuthService.revanista.user.identify();
          console.log("Auth session refreshed with new attributes");
        } catch (error) {
          console.error("Error refreshing auth session:", error);
        }
      })
      .catch((err) => console.log(err));
    console.log(
      "Monthly rate reminder set to false",
      this.props.user.monthlyRateReminder,
    );
  };

  private getCurrentHotelId(): string | null {
    const activeHotelId = this.props.activeHotel?.hotelId;
    if (activeHotelId) {
      return String(activeHotelId);
    }

    const pathname = window.location.pathname;
    const segments = pathname.split("/").filter(Boolean);
    const first = segments[0];
    if (!first) return null;
    if (!/^\d+$/.test(first)) return null;
    return first;
  }

  private getPathHotelId(): string | null {
    const pathname = window.location.pathname;
    const segments = pathname.split("/").filter(Boolean);
    const first = segments[0];
    if (!first) return null;
    if (!/^\d+$/.test(first)) return null;
    return first;
  }

  private canShowNewRevanistaCTA(hotelId: string | null): boolean {
    if (!hotelId) {
      return false;
    }

    return true;
  }

  private handleDismissNewRevanistaPrompt = () => {
    this.setState({ hasDismissedNewRevanistaPrompt: true });
  };

  private handleDismissMigrationNotice = async () => {
    try {
      await UserApi.acknowledgeMigrationNotice();
      this.setState({ hasDismissedMigrationNotice: true });
    } catch (error) {
      console.error("Failed to acknowledge migration notice:", error);
      this.setState({ hasDismissedMigrationNotice: true });
    }
  };

  private handleGoToNewPlatform = async () => {
    try {
      await UserApi.acknowledgeMigrationNotice();
    } catch (error) {
      console.error("Failed to acknowledge migration notice:", error);
    }
    const baseUrl =
      process.env.REACT_APP_NEW_EXP_URL || "https://app.revanista.com";
    window.location.href = baseUrl;
  };

  private handleGoToNewRevanista = async (hotelId: string | null) => {
    if (!hotelId) {
      toast.error("Unable to determine the hotel context.");
      return;
    }
    console.log("REACT_APP_NEW_EXP_URL", process.env.REACT_APP_NEW_EXP_URL);
    const baseUrl = process.env.REACT_APP_NEW_EXP_URL;
    if (!baseUrl) {
      toast.error("New Revanista URL is not configured.");
      return;
    }

    this.setState({ isRedirectingToNewRevanista: true });

    // Best effort: sign out of current app before navigating away
    try {
      await this.logout();
    } catch (e) {
      console.error("Failed to log out before redirecting", e);
    }

    // Always attempt the redirect
    try {
      await goToNewRevanista(hotelId, baseUrl);
    } catch (error) {
      console.error("Failed to open the new Revanista", error);
      toast.error("We couldn't redirect you. Please try again.");
      this.setState({ isRedirectingToNewRevanista: false });
    }
  };

  render() {
    console.log("user", this.props.user);

    let firstRoute: number | null = null;
    const pathname = window.location.pathname;
    const parts = pathname.split("/");

    // Validate and parse route
    if (parts[1] && parts[1].length > 0) {
      const parsedRoute = parseInt(parts[1]);
      if (!isNaN(parsedRoute)) {
        firstRoute = parsedRoute;
        // Override with first hotel if only one exists
        if (this.props.hotels && this.props.hotels.length === 1) {
          firstRoute = parseInt(this.props.hotels[0].hotelId);
        }
      }
    }

    console.log("first route ", firstRoute);

    const currentHotelId = this.getCurrentHotelId();
    const canShowNewRevanistaCTA = this.canShowNewRevanistaCTA(currentHotelId);
    const pathHotelId = this.getPathHotelId();
    const shouldShowNewRevanistaPopup =
      !!pathHotelId &&
      NEW_REVA_ELIGIBLE_HOTEL_IDS.has(pathHotelId) &&
      hasPermission(ACTIONS.NEW_EXP) &&
      !this.state.hasDismissedNewRevanistaPrompt;

    const isOnHomePage = pathname === "/";
    const isOnDashboard = !!pathHotelId;
    const hasMultipleHotels = this.props.hotels && this.props.hotels.length > 1;

    const shouldShowMigrationNotice =
      !this.state.hasDismissedMigrationNotice &&
      (isOnHomePage || isOnDashboard);

    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() + 23);
    const after23Months = currentDate.toLocaleDateString("en-US", {
      month: "long",
      year: "numeric",
    });

    return (
      <>
        <SessionHandler />
        <BrowserRouter>
          {!this.state.isInitialized ? (
            <Backdrop open={true} invisible={true}>
              <CircularProgress color="inherit" id="circular-progress" />
            </Backdrop>
          ) : this.state.invalidHotelId ? (
            <Fragment>
              <PageNotFound
                activeHotelId={firstRoute}
                onLogout={this.logout}
                username={this.props.user.username}
                changeIDState={this.changeInvalidIdStaten}
              />
            </Fragment>
          ) : (
            <Fragment>
              {!this.props.hotels || this.props.hotels.length === 0 ? (
                <Backdrop open={true} invisible={true}>
                  <CircularProgress color="inherit" id="circular-progress" />
                </Backdrop>
              ) : (store.getState() as any).appState.hasError ? (
                <div className="no-data--simple-header-text">
                  <h1 className="text-center">
                    An unexpected error has occurred!
                  </h1>
                </div>
              ) : (
                <Fragment>
                  <Navbar
                    onLogout={this.logout}
                    username={this.props.user.username}
                    activeHotelId={firstRoute}
                    showNewExperienceButton={canShowNewRevanistaCTA}
                    isNewExperienceLoading={
                      this.state.isRedirectingToNewRevanista
                    }
                    onGoToNewExperience={() =>
                      this.handleGoToNewRevanista(currentHotelId)
                    }
                  />
                  <ToastContainer hideProgressBar={true} />
                  <Routes>
                    <Route
                      path="/"
                      element={
                        <>
                          <HomePage />
                        </>
                      }
                    />
                    {hasPermission(ACTIONS.ONBOARD_HOTEL) && (
                      <>
                        <Route
                          path="onboard-hotel"
                          element={
                            <>
                              <OnboardHotel />
                            </>
                          }
                        />
                      </>
                    )}
                    <Route path="admin" element={<UserDashboard />} />
                    <Route path="/:hotelId" element={<Dashboard />} />
                    <Route path="/:hotelId/settings" element={<Settings />}>
                      <Route
                        path="executive-summary"
                        element={
                          <>
                            <ExecSummary />
                          </>
                        }
                      />
                      <Route path="user" element={<Users />} />
                      <Route
                        path="hotel-config"
                        element={
                          <>
                            <NewHotelConfig authData={this.props.authData} />
                          </>
                        }
                      />
                      <Route
                        path="rooms"
                        element={
                          <>
                            <RoomConfig />
                          </>
                        }
                      />
                      {hasPermission(ACTIONS.EDIT_COMPSET) && (
                        <Route
                          path="competitive-set"
                          element={
                            <>
                              <NewCompSetConfig />
                            </>
                          }
                        />
                      )}
                    </Route>

                    <Route
                      path="*"
                      element={
                        <PageNotFound
                          activeHotelId={firstRoute}
                          onLogout={this.logout}
                          username={this.props.user.username}
                          changeIDState={this.changeInvalidIdStaten}
                        />
                      }
                    />
                  </Routes>
                </Fragment>
              )}
              <Popup
                isPopupOpen={this.props.user.monthlyRateReminder}
                closeOnOutsideClick={true}
                title="Reminder"
                content={[
                  ` ${after23Months} is now available for rate loading. Please action at
          your convenience.`,
                ]}
                cancelAction={this.handleOnRemindMeLater}
                cancelName="Remind me later"
                action={this.handleOnPopupClose}
                actionName="OK"
              />
              <Popup
                isPopupOpen={shouldShowMigrationNotice}
                closeOnOutsideClick={false}
                title="Important: Platform Migration Notice"
                content={[
                  <div
                    key="migration-notice-message"
                    style={{ textAlign: "left" }}
                  >
                    <p>
                      This is to inform you that the legacy Revanista platform,
                      accessible via https://prod.revanista.com , will{" "}
                      <strong>no longer be accesible</strong> from{" "}
                      <strong>17 April 2026</strong>.
                    </p>
                    <p>
                      To ensure <strong>uninterrupted access</strong>, please
                      use the new Revanista application at{" "}
                      <a
                        href="https://app.revanista.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        https://app.revanista.com
                      </a>
                      .
                    </p>
                    <p>
                      We&apos;re excited to bring you new features exclusively
                      on the Revanista 2.0, including upcoming charts,
                      reporting, and insights.
                    </p>
                    <p style={{ fontWeight: "bold", marginTop: "16px" }}>
                      Existing features available on the new Revanista (and not
                      available on the legacy platform) include:
                    </p>
                    <ul style={{ marginLeft: "20px", marginBottom: "16px" }}>
                      <li>Improved bulk update tools</li>
                      <li>Support for multiple temporary periods</li>
                      <li>Configurable notification preferences</li>
                      <li>Centralised notification center</li>
                      <li>Enhanced executive summary</li>
                    </ul>
                    <p>
                      The new Revanista also offers enhanced security, refreshed
                      user interface, a modernized framework, and improved
                      long-term support.
                    </p>
                    <p
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "16px",
                        fontStyle: "italic",
                      }}
                    >
                      Note: By accessing the new Revanista or acknowledging this
                      pop up, you acknowledge this notice.
                    </p>
                  </div>,
                ]}
                cancelAction={this.handleDismissMigrationNotice}
                cancelName="Acknowledge"
                cancelColor="error"
                action={this.handleGoToNewPlatform}
                actionName="Go to New Revanista"
              />
            </Fragment>
          )}
        </BrowserRouter>
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  activeHotel: state.hotelData.activeHotel,
  hotels: state.hotelData.hotels,
  user: state.user,
});

const mapDispatchToProps = (dispatch: any) => ({
  setMonthlyRateReminder: (value: boolean) =>
    dispatch(setMonthlyRateReminder(value)),
});

const AppObserver = connect(mapStateToProps, mapDispatchToProps)(App);
export { AppObserver as App };

export default withAuthenticator(AppObserver, false, [
  <SignIn key="SignIn" />,
  <ConfirmSignIn key="ConfirmSignIn" />,
  <SignUp key="SignUp" />,
  <ConfirmSignUp key="ConfirmSignUp" />,
  <RequireNewPassword key="RequireNewPassword" />,
  <VerifyContact key="VerifyContact" />,
  <ForgotPassword key="ForgotPassword" />,
  <ResetPassword key="ResetPassword" />,
]);
